import type { AuthProvider } from '../contracts';

/**
 * The Rematch and Kinde reads the identity hook used to take itself.
 * Kinde fields cross raw; the package applies its own coercions.
 */
export interface AuthIdentityInputs {
  reduxProvider: AuthProvider | null | undefined;
  legacyAuthToken: string | null | undefined;
  externalLaunchToken: string | null | undefined;
  kinde: {
    isAuthenticated?: boolean | null;
    isLoading?: boolean | null;
  };
}

/** The one app-wired seam. The package never imports the store. */
export interface AuthIdentityConfig {
  useAuthIdentityInputs: () => AuthIdentityInputs;
  getEffectiveAuthProvider: () => AuthProvider | null;
  isTauri: () => boolean;
}

let config: AuthIdentityConfig | undefined;

export function configureAuthIdentity(next: AuthIdentityConfig): void {
  config = next;
}

/** Throws when nothing has called `configureAuthIdentity`. Names the seam only. */
export function getAuthIdentityConfig(): AuthIdentityConfig {
  if (!config) {
    throw new Error('[auth/state] configureAuthIdentity() has not been called');
  }
  return config;
}

/** Test-only. Clears the seam so a later file starts unconfigured. */
export function resetAuthIdentityForTests(): void {
  config = undefined;
}
